import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from '@fluentui/react/lib';
import { FreeBusyType, isConflictFromFreeBusy } from 'owa-freebusy-cache';

let styles = require('./FreeBusyBadgeBase.scss');
let classNames = require('classnames/bind').bind(styles);

export interface FreeBusyBadgeBaseProps {
    freeBusyType: FreeBusyType;
    isResource: boolean;
}

function FreeBusyBadgeBase(props: FreeBusyBadgeBaseProps) {
    const { freeBusyType, isResource } = props;
    const unknownStatus: boolean =
        freeBusyType === FreeBusyType.NoData || freeBusyType === FreeBusyType.Loading;
    const freeStatus: boolean = !unknownStatus && !isConflictFromFreeBusy(freeBusyType, isResource);

    return (
        <div
            className={classNames(styles.freeBusyStatus, {
                free: freeStatus,
                unknown: unknownStatus,
            })}>
            <Icon
                iconName={
                    unknownStatus
                        ? ControlIcons.Help
                        : freeStatus
                        ? ControlIcons.Accept
                        : ControlIcons.Cancel
                }
                className={styles.freeBusyIcon}
            />
        </div>
    );
}
export default FreeBusyBadgeBase;
